import { Injectable } from '@angular/core';

import { ProductFabricSpec } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductFabricSpecService extends TmsWebBaseEditService<ProductFabricSpec, ProductFabricSpec> {
  constructor() {
    super('FabricSpec', $localize`Fabric Spec`);
  }
}
